import { render } from "./NotesListModal.vue?vue&type=template&id=1f35449e&scoped=true&ts=true"
import script from "./NotesListModal.vue?vue&type=script&lang=ts"
export * from "./NotesListModal.vue?vue&type=script&lang=ts"

import "./NotesListModal.vue?vue&type=style&index=0&id=1f35449e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f35449e"]])

export default __exports__